<ng-container>
  <mat-form-field appearance="outline" class="d-block no-padding">
    <input
      matInput
      type="number"
      [value]="value"
      [placeholder]="placeholder | translate"
      class="show-number-spinners"
      [disabled]="isDisabled"
      (input)="onInput($event)"
    />
    <div matSuffix class="counter-buttons flex column align-center justify-center brd">
      <button type="button" class="counter-btn up bg-white cursor-pointer" [disabled]="isDisabled" (click)="increaseValue()" aria-label="increase">
        <app-icon class="text-400 icon" name="bold-arrow-down-no-box" size="xs"></app-icon>
      </button>
      <button type="button" class="counter-btn down bg-white cursor-pointer" [disabled]="isDisabled" (click)="decreaseValue()" aria-label="decrease">
        <app-icon class="text-400" name="bold-arrow-down-no-box" size="xs"></app-icon>
      </button>
    </div>
  </mat-form-field>
</ng-container>